<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()">

    <mat-form-field appearance="outline">
      <mat-label>Year</mat-label>
      <mat-select [formControl]="yearControl">
        <mat-option *ngFor="let year of years" [value]="year">{{year}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="countryCategory === 'putonmarket'">
      <mat-label>KF Configuration</mat-label>
      <mat-select value="NEW" [formControl]="categoryTypeControl" (selectionChange)="getCategories($event)">
        <mat-option value="NEW">8 cat. – from 2019</mat-option>
        <mat-option value="OLD">16 cat. - before 2019</mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>Detail Level</mat-label>
      <mat-select [formControl]="detailLevelControl">
        <mat-option value="" (click)="b2bB2cControl.setValue(null)">-</mat-option>
        <mat-option value="DIFFERENTIATED">Differentiated</mat-option>
        <mat-option value="UNDIFFERENTIATED" (click)="b2bB2cControl.setValue(null)">UnDifferentiated</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>B2B/B2C</mat-label>
      <mat-select [formControl]="b2bB2cControl" [disabled]="detailLevelControl.value !== 'DIFFERENTIATED'">
        <mat-option value="">-</mat-option>
        <mat-option value="B2B">B2B</mat-option>
        <mat-option value="B2C">B2C</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Member</mat-label>
      <mat-select formControlName="member">
        <mat-option value="">-</mat-option>
        <mat-option value="member">EU Member</mat-option>
        <mat-option value="non-member">Non-EU Member</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Region</mat-label>
      <mat-select formControlName="region">
        <mat-option value=""> - </mat-option>
        <mat-option *ngFor="let region of regions" [value]="region.value">{{region.name}}</mat-option>
      </mat-select>
    </mat-form-field>

<!--    <mat-form-field appearance="outline">-->
<!--      <mat-label>Order</mat-label>-->
<!--      <mat-select [formControl]="orderControl">-->
<!--        <mat-option value="">{{"charts.filters.order.alphabetical" | translate}}</mat-option>-->
<!--        <mat-option [value]="'asc'">{{"charts.filters.order.ascending" | translate}}</mat-option>-->
<!--        <mat-option [value]="'desc'">{{"charts.filters.order.descending" | translate}}</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <button type="button" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary" [disabled]="yearControl.value > 2018 && categoryTypeControl.value === 'OLD'">Apply</button>
    <app-new-tab-button></app-new-tab-button>

  </form>
</div>
